import { render, staticRenderFns } from "./GptUpscaling.vue?vue&type=template&id=bdffc210&scoped=true"
import script from "./GptUpscaling.vue?vue&type=script&lang=js"
export * from "./GptUpscaling.vue?vue&type=script&lang=js"
import style0 from "./GptUpscaling.vue?vue&type=style&index=0&id=bdffc210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdffc210",
  null
  
)

export default component.exports